import { initializeApp } from "firebase/app";
import { getMessaging, onMessage, getToken } from "firebase/messaging";
import { onBackgroundMessage } from "firebase/messaging/sw";

const firebaseApp = initializeApp({
  apiKey: "AIzaSyCsWhbRXO0WKetDm4petrQsmGkZTaFGXu4",
  authDomain: "logbog-27528.firebaseapp.com",
  projectId: "logbog-27528",
  storageBucket: "logbog-27528.appspot.com",
  messagingSenderId: "321596051912",
  appId: "1:321596051912:web:cb444e9a54962bef0f70fd",
  measurementId: "G-M2LTPQC69G"
});

const messaging = getMessaging(firebaseApp);

getToken(messaging, {vapidKey: "BIbx8lvCeFTxkgQVE7PnV7OuoZAmo7MDAiF3fV2mrX2nknET-xyGYf60iOEaDJP4ZwetGX26bKumRv6yE2j1w4M"})
  .then((currentToken) => {
    if (currentToken) {
      console.log('Firebase token :', currentToken);
      localStorage.setItem('fcm_token', currentToken);
    } else {
      console.log('No registration token available. Request permission to generate one.');
    }
  }).catch((err) => {
  console.log('An error occurred while retrieving token. ', err);
});

// onBackgroundMessage(messaging, (payload) => {
//   console.log('[firebase-messaging-sw.js] Received background message ', payload);
//   // Customize notification here
//   const notificationTitle = 'Background Message Title';
//   const notificationOptions = {
//     body: 'Background Message body.',
//     icon: '/firebase-logo.png'
//   };

//   self.registration.showNotification(notificationTitle,
//     notificationOptions);
// });

//To handle foreground messages
// onMessage(messaging, (message) => {
//   console.log(message);
// });

